import React from "react";
import Project from "../components/Project";
import "./Projects.css";

function Projects() {
  return (
    <div className="projects-section">
      <div className="projects-title-container">
        <h1 className="section-title">PROJECTS</h1>
        <h3 className="section-subtitle">What I make</h3>
      </div>
      <div className="projects">
        <div className="projects-container">
          <Project
            image="https://www.svgrepo.com/show/81376/footsteps-silhouette-variant.svg"
            title="Free Walking Tours App"
            link="https://walking-tour.netlify.app"
            description="Free Walking Tours (group-project) is an app where you can search and enroll for walking tours in Amsterdam."
          />
        </div>
        <div className="projects-container">
          <Project
            image="https://cdn2.iconfinder.com/data/icons/video-game-39/32/s_snake_game-512.png"
            title="Snake Game"
            link="https://eriks-snake.netlify.app"
            description="This snake game is created in vanilla JavaScript. Try not to hit the walls or eating yourself."
          />
          <Project
            image="https://www.nicepng.com/png/full/253-2535995_keyboard-svg-printable-computer-keyboard.png"
            title="Keyboard Game"
            link="https://the-keyboard-game.netlify.app"
            description="This is a game in which you have to press the right key within the given time. The amount of time shrinks."
          />
        </div>
      </div>
    </div>
  );
}

export default Projects;
